import { authFetch } from '../../../auth'
import { useState, useEffect } from "react";
import { buildPriceListApiUrl } from '../helpers/priceListUrlHelpers'

export const useLoadPriceList = (baseBackendUrl) => {
    const [initialLoading, setInitialLoading] = useState(true);
    const [error, setError] = useState(null);

    const [isEditing, setIsEditing] = useState(false);
    const [isCopy, setIsCopy] = useState(false);

    const [listInfo, setListInfo] = useState({
        uidPrices: "",
        title: "",
        clients: [],
        products: []
    });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const copyUid = params.get("copy");
        const editUid = params.get("edit");

        if (!copyUid && !editUid) {
            setInitialLoading(false);
            return;
        }

        const uid = copyUid || editUid;

        const fetchData = async () => {
            try {
                const response = await authFetch(buildPriceListApiUrl(baseBackendUrl, 'price_lists', uid), {
                });

                if (!response.ok) throw new Error("Error al cargar lista.");

                const data = await response.json();

                const importData = data.imports?.[0] || {};

                const clients = (importData.clients || []).map((c) => ({
                    uid: c.uid,
                    name: c.client_name,
                    active: true,
                    address: c.address || "",
                }));

                const products = (importData.products || []).map((p) => ({
                    db_ref: p.db_ref,
                    name: p.product_name,
                    unit: p.unit,
                    base_price: p.base_price,
                    price: p.price,
                }));

                if (editUid) {
                    setIsEditing(true);
                    setListInfo({
                        uidPrices: data.price_list.db_ref,
                        title: data.price_list.description,
                        clients,
                        products,
                    });
                }

                if (copyUid) {
                    setIsCopy(true);
                    setListInfo({
                        uidPrices: "",
                        title: "",
                        clients: [],
                        products,
                    });
                }
            } catch (err) {
                console.error(err);
                setError("No se pudo cargar la lista.");
            } finally {
                setInitialLoading(false);
            }
        };

        fetchData();
    }, [baseBackendUrl]);

    return {
        initialLoading,
        error,
        isEditing,
        isCopy,
        listInfo,
    };
};
